/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddBrokerToGroupContractCommand
 */
export interface AddBrokerToGroupContractCommand {
    /**
     * 
     * @type {string}
     * @memberof AddBrokerToGroupContractCommand
     */
    brokerId: string;
}

/**
 * Check if a given object implements the AddBrokerToGroupContractCommand interface.
 */
export function instanceOfAddBrokerToGroupContractCommand(value: object): value is AddBrokerToGroupContractCommand {
    if (!('brokerId' in value) || value['brokerId'] === undefined) return false;
    return true;
}

export function AddBrokerToGroupContractCommandFromJSON(json: any): AddBrokerToGroupContractCommand {
    return AddBrokerToGroupContractCommandFromJSONTyped(json, false);
}

export function AddBrokerToGroupContractCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddBrokerToGroupContractCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'brokerId': json['brokerId'],
    };
}

export function AddBrokerToGroupContractCommandToJSON(json: any): AddBrokerToGroupContractCommand {
    return AddBrokerToGroupContractCommandToJSONTyped(json, false);
}

export function AddBrokerToGroupContractCommandToJSONTyped(value?: AddBrokerToGroupContractCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'brokerId': value['brokerId'],
    };
}

